import React, { useState } from 'react'
import { motion } from "framer-motion";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Header from '../component/Header';
import Footer from '../component/Footer';
import QR from '../assets/qr.jpeg';
import { useNavigate } from "react-router-dom";
import PaymentModal from "../component/Payment/PaymentModal";
import "../css/PayNow.css"

export default function Paynow() {

  const [content, setContent] = useState("pannumber");
  const [getLoading, setLoading] = useState(false);
  const [getPancard, setPancard] = useState("");
  const [getOtp, setOtp] = useState("");
  const [repaymentData, setRepaymentData] = useState(null);
  const [orderId, setOrderId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [otpError, setOtpError] = useState(""); // New state for OTP error
  const [panError, setPanError] = useState(""); // New state for PAN error
  const [paymentAmount, setPaymentAmount] = useState(); // New state for part payment
  const [paymentGateways, setPaymentGateways] = useState();
  const navigate = useNavigate();


  // const steps = [
  //   {
  //     icon: '01',
  //     title: 'Access the Repayment Section',
  //     description: 'Click on the Repay Loan option available on the B4Salary website or the repayment link shared directly with you.',

  //   },
  //   {
  //     icon: '02',
  //     title: 'Enter Account Details',
  //     description: 'Enter your PAN or registered details so we can retrieve your loan account information.',

  //   },
  //   {
  //     icon: '03',
  //     title: 'Confirm Your Identity',
  //     description: 'A verification OTP will be sent to your registered mobile number. Enter it to confirm your identity securely.',

  //   },
  //   {
  //     icon: '04',
  //     title: 'Review Loan Information',
  //     description: 'View your outstanding balance, due amount, and repayment information for your account.',

  //   },
  //   {
  //     icon: '05',
  //     title: 'Select Repayment Amount',
  //     description: 'Choose whether you would like to make a full payment or continue with a partial payment option.',
  //   },
  //   {
  //     icon: '06',
  //     title: 'Continue to Payment',
  //     description: 'Select Pay Now and choose your preferred payment method, such as UPI, credit card, debit card, or netbanking.',
  //   },
  //   {
  //     icon: '07',
  //     title: 'Get Payment Confirmation',
  //     description: 'Once your payment is successfully completed, confirmation details will be sent via SMS and to your registered email address.',
  //   }

  // ];
  // return (
  //   <div>
  //     <Header />
  //     {/* banner section start */}
  //     <div className="relative h-[500px] flex items-center justify-center bg-gradient-to-br from-[#0b1f3a] to-[#0a2540] overflow-hidden">
  //       {/* Animated Background Glow */}
  //       <div className="absolute w-[400px] h-[400px] bg-blue-500/20 rounded-full blur-3xl animate-pulse top-[-100px] left-[-100px]" />
  //       <div className="absolute w-[300px] h-[300px] bg-orange-400/20 rounded-full blur-3xl animate-pulse bottom-[-80px] right-[-80px]" />

  //       {/* Glass Card */}
  //       <motion.div
  //         initial={{ opacity: 0, y: 40 }}
  //         animate={{ opacity: 1, y: 0 }}
  //         transition={{ duration: 0.8 }}
  //         className="px-10 py-8 text-center "
  //       >
  //         <div className="w-full max-w-lg mx-auto bg-white rounded-2xl shadow-lg border border-slate-200 p-6 sm:p-8">

  //           {/* Heading */}
  //           <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">
  //             Repay Loan
  //           </h2>

  //           {/* Description */}
  //           <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">
  //             Kindly verify your details before proceeding with your loan repayment. For repayment-related queries or support assistance, please contact us at
  //             {" "}
  //             <span className="font-medium text-orange-500">
  //               care@b4salary.com.
  //             </span>
  //           </p>

  //           {/* Sub Heading */}
  //           <h5 className="mt-5 text-sm sm:text-base font-medium text-slate-800">
  //            Log in securely using your PAN and OTP to access your loan details and continue with repayment.
  //           </h5>

  //           {/* Input */}
  //           <div className="mt-5">
  //             <input
  //               type="text"
  //               placeholder="Enter PAN No."
  //               className="w-full h-12 rounded-xl border border-slate-300 bg-white px-4 text-sm text-slate-800 placeholder:text-slate-400 outline-none transition-all focus:border-orange-500 focus:ring-4 focus:ring-orange-100"
  //             />
  //           </div>

  //           {/* Button */}
  //           <button className="mt-5 w-full h-12 rounded-xl bg-orange-500 text-white font-medium hover:bg-orange-600 transition-all duration-300">
  //             Continue
  //           </button>
  //         </div>


  //       </motion.div>
  //     </div>

  //     {/* end */}

  //     <div className='max-w-7xl m-auto'>
  //       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4 py-15 ">
  //         {steps.map((doc, index) => (
  //           <div
  //             key={index}
  //             className="bg-white border-2 border-gray-50 rounded-lg p-6 hover:shadow-lg transition-shadow"
  //           >
  //             <div className="w-12 h-12 bg-orange-300 rounded-full flex items-center justify-center mb-4 font-bold text-2xl">
  //               {/* <doc.icon className="w-6 h-6 text-white" /> */}
  //               {doc.icon}
  //             </div>
  //             <h3 className="text-xl font-semibold text-slate-600 mb-2">
  //               {doc.title}
  //             </h3>
  //             <p className="text-sm text-slate-600 mb-4 leading-relaxed">
  //               {doc.description}
  //             </p>


  //           </div>
  //         ))}

  //         <div className="bg-gradient-to-br from-slate-800 to-teal-800 rounded-lg p-6 text-white flex flex-col justify-between">
  //           <div>
  //             <div className="w-12 h-12 bg-teal-500/30 rounded-full flex items-center justify-center mb-4">
  //               <SupportAgentIcon className="w-6 h-6 text-teal-300" />
  //             </div>
  //             <h3 className="text-xl font-semibold mb-3">Need Help?</h3>
  //             <p className="text-sm text-slate-300 mb-6 leading-relaxed">
  //               Our loan support team is available 24/7 to assist you with repayment-related queries and help you with any account-related concerns.
  //             </p>
  //           </div>
  //           <button className="w-full bg-white text-slate-900 px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors">
  //             Speak with an Expert
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //     <Footer/>
  //   </div>

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const sendOtp = async () => {
    setLoading(true);
    // Check if PAN number is empty
    if (!getPancard) {
      setPanError("PAN card is required.");
      setLoading(false);
      return;
    } else {
      setPanError("");
    }

    try {
      const resp = await fetch("https://crm.b4salary.co.in/api/Api/CustomerDetails/Sendotp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Auth: "Y2M0Nzk0OGYwNmQyMjdmZTlhY2E1ZWQ1Nzk5YTZmMWE=",
          Accept: "application/json",
        },
        body: JSON.stringify({ pancard: getPancard }),
      });

      const dataset = await resp.json();

      if (resp.status === 200) {
        console.log(dataset.Message);
        if (dataset.Status === 1) {
          setContent("panotp");
        } else {
          // Display error if status is not 1
          console.log(dataset.Message);
        }
      } else {
        // Show API error message
        console.log(dataset.Message);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      console.log("An error occurred while sending OTP.");
    } finally {
      setLoading(false);
    }
  };


  const verifyOtp = async () => {
    if (!isChecked) {
      console.log("Please accept the terms and conditions to proceed.");
      return;
    }

    // Check if OTP field is empty
    if (!getOtp) {
      setOtpError("OTP is required.");
      return;
    } else {
      setOtpError(""); // Clear the error message if OTP is valid
    }

    setLoading(true);
    try {
      const resp = await fetch("https://crm.b4salary.co.in/api/Api/CustomerDetails/verifyOtp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Auth: "Y2M0Nzk0OGYwNmQyMjdmZTlhY2E1ZWQ1Nzk5YTZmMWE=",
          Accept: "application/json",
        },
        body: JSON.stringify({
          pancard: getPancard,
          otp: getOtp,
        }),
      });

      const dataset = await resp.json();

      if (resp.status === 200) {
        console.log(dataset.Message);

        if (dataset.Status === 1) {
          const repaymentData = dataset.repayment_data;
          setRepaymentData(repaymentData);
          setOrderId(dataset.order_id);
          setContent("amountfetched");
          if (dataset?.pg_data && dataset.pg_data.length > 0) {
            setPaymentGateways(dataset.pg_data);
          }
        } else {
          // Show error if status is not 1
          setOtpError(dataset.Message);  // Display OTP verification error message
        }
      } else {
        // Show error if the API response is not successful
        setOtpError(dataset.Message);  // Display OTP verification error message
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpError("An error occurred while verifying OTP.");
    } finally {
      setLoading(false);
    }
  };



  const payHere = async () => {
    setLoading(true);
    try {
      var total_due_amount = repaymentData.total_due_amount;
      if (paymentAmount < repaymentData.total_due_amount) {
        total_due_amount = paymentAmount; // Use part payment amount if provided
      }

      // let pgConfig = paymentGateways.find((pg) => pg.mpg_gateway_name == 'Razorpay');

      const options = {
        key: 'rzp_live_TkA5gPfXVk95LS',
      
        amount: (total_due_amount * 100).toString(),
        currency: "INR",
        name: "B4salary",
        description: getPancard,
        image: "https://web.b4salary.com/public/images/final_logo.png",
        order_id: orderId,
        prefill: {
          name: "Hidden",
          email: repaymentData.email,
          contact: repaymentData.mobile,
        },
        theme: { color: "#ff7b0e" },
        handler: function (response) {
          console.log('response',response)
          const paymentDetails = {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
            company_id: 1
          };

          fetch("https://crm.b4salary.co.in/api/Api/CustomerDetails/verifyRazorPayCheckPaymentStatus", {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
              // Auth: "Y2M0Nzk0OGYwNmQyMjdmZTlhY2E1ZWQ1Nzk5YTZmMWE=",
              Accept: "application/json",
            },
            body: JSON.stringify(paymentDetails),
          })
            .then((res) => res.json())
            .then((data) => {
              let txnStatus = data.status
              let txnId = data.txnId || "N/A";  // Get txnId from response if available

              // Pass txnStatus and txnId to the thank you page using navigate
              navigate("/thanku", {
                state: {
                  txnStatus: txnStatus,
                  txnId: txnId,
                },
              });

              setPaymentStatus(txnStatus === 'SUCCESS' ? "Payment Successful" : "Payment Verification Failed");
              setContent(txnStatus === 'SUCCESS' ? "paymentSuccess" : "paymentFailure");
              setLoading(false);
            })
            .catch((error) => {
              console.error("Error verifying payment:", error);
              setPaymentStatus("Payment Verification Failed");
              setLoading(false);
            });
        },
      };

      const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
      if (res) {

        console.log(options);
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } else {
        alert("Razorpay SDK failed to load. Are you online?");
      }
    } catch (error) {
      console.error("Error during payment:", error);
      setLoading(false);
    }
  };

   const handlePAN = (e) => {
    const value = e.target.value.toUpperCase();
    if (/^[A-Z]{0,5}$/.test(value.slice(0, 5)) && /^[\d]{0,4}$/.test(value.slice(5, 9)) && /^[A-Z]{0,1}$/.test(value.slice(9))) {
      setPancard(value);
      setPanError("");
    }
  };

  const handleOTP = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 4) {
      setOtp(value);
      setOtpError("");
    }
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };




  const handlePaymentClick = () => {
    setModalOpen(true);
    setLoading(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleRazorpay = () => {
    setModalOpen(false);
    payHere();
    setLoading(false);
  };

  const handlePaymentAmountChange = (e) => {
    let value = e.target.value;

    // Prevent the value from starting with 0, but allow decimal numbers
    if (value.length === 1 && value === '0') {
      // Do nothing if the input is just "0"
      return;
    }

    // Regex to ensure the input doesn't start with a "0" unless it's "0." (i.e., decimal number like 0.50 is allowed)
    const regex = /^(?!0(\.\d+)?)(\d*\.?\d*)$/;

    // Only update if the value matches the regex pattern
    if (regex.test(value) || value === "") {
      setPaymentAmount(value);
    }
  };

  return(
    <>
    <Header/>

    <div className="page_wrapper">

          <div className="repay_loan_wrapper" style={{ marginTop: "70px" }}>
            <div className="repay_loan_section">

              {/* ---------------- PAN CARD INPUT CARD ---------------- */}
              {content === "pannumber" && (
                <div className="card-container">
                  <div className="card-box">
                    <h2 className="card-title">Repay Loan</h2>
                    <p className="card-subtext">
                      Please verify the accuracy of the below details before doing any transfer.
                    </p>

                    <label className="card-label">Enter your PAN</label>
                    <input
                      type="text"
                      className="card-input"
                      value={getPancard}
                      onChange={handlePAN}
                      maxLength={10}
                      required
                    />

                    {panError && (
                      <p className="error_message" style={{ color: "red" }}>
                        {panError}
                      </p>
                    )}

                    <button className="card-button" onClick={sendOtp}>
                      {getLoading ? <div className="loadinganim"></div> : "Get OTP"}
                    </button>
                  </div>
                </div>
              )}

              {/* ---------------- OTP CARD ---------------- */}
              {content === "panotp" && (
                <div className="card-container">
                  <div className="card-box">
                    <h2 className="card-title">Verify OTP</h2>
                    <p className="pan_details mb20">PAN NUMBER : {getPancard}</p>

                    <input
                      type="text"
                      className="card-input"
                      placeholder="Enter the OTP received"
                      value={getOtp}
                      onChange={handleOTP}
                      maxLength={4}
                    />

                    {otpError && (
                      <p className="error_message" style={{ color: "red" }}>
                        {otpError}
                      </p>
                    )}

                    <div className="checkbox-row">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />
                      <span>
                        To proceed, please accept our Terms & Conditions & provide consent.
                      </span>
                    </div>

                    {!isChecked && (
                      <p className="error_message" style={{ color: "red" }}>
                        You must accept the terms & conditions to proceed.
                      </p>
                    )}

                    <button
                      className="card-button"
                      onClick={verifyOtp}
                      disabled={!isChecked || otpError}
                    >
                      {getLoading ? <div className="loadinganim"></div> : "Get Amount"}
                    </button>
                  </div>
                </div>
              )}

              {/* ---------------- AMOUNT FETCHED CARD ---------------- */}
              {content === "amountfetched" && repaymentData && (
                <div className="repayment-card">
                  <div className="repayment-header">
                    <h2>Loan Repayment Details</h2>
                  </div>

                  <div className="repayment-info">
                    <div className="info-item">
                      <span className="label">Loan Number:</span>
                      <span className="value">{repaymentData.loan_no}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Disbursal Date:</span>
                      <span className="value">{repaymentData.disbursal_date}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Repayment Date:</span>
                      <span className="value">{repaymentData.repayment_date}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Repayment Amount:</span>
                      <span className="value">₹{repaymentData.repayment_amount.toLocaleString()}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Loan Amount:</span>
                      <span className="value">₹{repaymentData.loan_recommended.toLocaleString()}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Real Interest:</span>
                      <span className="value">₹{repaymentData.real_interest.toLocaleString()}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">Repayment With Interest:</span>
                      <span className="value">₹{repaymentData.total_due_amount.toLocaleString()}</span>
                    </div>
                    <div className="info-item due-amount">
                      <span className="label">Total Due Amount:</span>
                      <span className="value">₹{repaymentData.repayment_with_real_interest.toLocaleString()}</span>
                    </div>
                    <div className="info-item part-amount">
                      <span className="label">Amount To Pay</span>
                      {/* Make the Amount To Pay field editable */}
                      <input
                        type="text"
                        value={paymentAmount}
                        onChange={handlePaymentAmountChange}
                        placeholder="Enter payment amount"
                      />
                    </div>
                  </div>


                  <div className="repayment-button-container">
                    <button className="repayment-button" onClick={handlePaymentClick}>
                      {getLoading ? <div className="loadinganim"></div> : "Proceed to Pay"}
                    </button>
                  </div>

                  {isModalOpen && (
                    <PaymentModal
                      onClose={handleCloseModal}
                      onRazorpay={handleRazorpay}
                    // onUpi={handleUpi}
                    />
                  )}
                  
                </div>
              )}

              {/* ---------------- PAYMENT SUCCESS ---------------- */}
              {content === "paymentSuccess" && (
                <div className="payment-success">
                  <h3>{paymentStatus}</h3>
                  <p>Thank you for your payment!</p>
                </div>
              )}

            </div>
          </div>

          <br />

        </div>
      
    <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr]">
        {/* Left Section */}
        <div className="px-24 py-24">
          <h1 className="text-[22px] font-semibold text-[#4b5fd1] mb-8">
            Bank Account Details
          </h1>

          <div className="space-y-10">
            {/* Row */}
            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                Account Name
              </p>
              <p className="text-15px text-gray-700 leading-relaxed">
                KISGA LEASING AND FINANCE PRIVATE LIMITED -B4Salary
              </p>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                Account No.
              </p>
              <p className="text-15px text-gray-700">135305003842</p>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                Bank Name
              </p>
              <p className="text-15px text-gray-700">ICICI Bank</p>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                IFSC Code
              </p>
              <p className="text-15px text-gray-700">ICIC0001353</p>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                Branch Address
              </p>
              <p className="text-15px text-gray-700">
                NETAJI SUBHASH PLACE, DELHI, INDIA
              </p>
            </div>

            <div className="grid grid-cols-2 pb-5">
              <p className="text-15px font-semibold text-gray-600">
                Account Type
              </p>
              <p className="text-15px text-gray-700">Current</p>
            </div>
          </div>

          {/* Footer Note */}
          <p className="mt-16 text-[20px] text-gray-700 leading-relaxed max-w-6xl">
            Please ensure the above details are used for official payments
            only. For UPI transfers, you may scan the QR code provided.
          </p>
        </div>

        {/* Right Section */}
        <div className="justify-center items-start py-8">
          <div >
            {/* Replace with actual image */}
            <img
              src={QR}
              alt="QR Payment"
              className="w-80 object-contain"
            />
          </div>
        </div>
    </div>
    
    </>
  )
  
}
